import * as amplitude from '@amplitude/analytics-browser';
import { CsAppsWheel, CsBeamer } from '@creative-suite/react-components';
import { storageHelper, User } from '@spo/logic';
import { Header, Modal } from '@spo/storybook';
import { VpButton, VpDivider, VpIcon } from '@vtmn-play/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { environment } from '../../environments/environment';
import { useParameters } from '../../hooks/useParameters';
import { ArchitectureModal } from '../architecture/ArchitectureModal';
import { UserButton } from '../user/UserButton';
import './header-display.scss';

export const HeaderDisplay = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalArchiOpen, setIsModalArchiOpen] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isOnArchitecturePage = location.pathname.includes('/architecture');

  const currentUser = storageHelper.getItem<User>('user')!;
  const { data: isArchiActivated } = useParameters({
    parameterName: 'VIEW_ARCHI',
    uid: currentUser?.uid,
  });

  const onModifyConfig = () => {
    navigate('/personal-offer/my-config');
  };

  const footerModal = (
    <VpButton
      data-testid="personal-offer_modal_user_button"
      startSlot={<VpIcon name="edit" />}
      shape="squared"
      size="medium"
      variant="primary"
      onClick={onModifyConfig}
    >
      {t('modify_config')}
    </VpButton>
  );

  return (
    <>
      <Modal
        dataTestid="personal-offer_modal_user"
        footer={footerModal}
        title={t('profile')}
        ariaLabel="Personal Offer User Modal"
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <UserButton user={currentUser} />
      </Modal>
      <Header
        env={!environment.production ? environment.env : undefined}
        logoHref="/personal-offer"
        logoTitle={t('header.title')}
        actions={[
          environment.beamerId ? (
            <CsBeamer
              data-testid="cs-beamer"
              key="cs-beamer"
              lang="en"
              productId={environment.beamerId}
              userId={currentUser?.uuid}
              userEmail={currentUser?.mail}
              userFirstname={currentUser?.givenName}
              userLastname={currentUser?.familyName}
              vtmnCompliant
              additionalCustomData={{
                user_country: currentUser?.c,
                user_job: currentUser?.jobname,
                user_role: currentUser?.role,
              }}
            />
          ) : null,
          !isOnArchitecturePage && isArchiActivated && (
            <div key="architecture_button">
              <VpButton
                variant="primary"
                data-testid="architecture-modal-container-button"
                className="architecture-modal-container-button"
                onClick={() => {
                  setIsModalArchiOpen(true);
                  amplitude.track('Architecture_Modal');
                }}
              >
                {t('architecture-title')}
              </VpButton>
              <ArchitectureModal
                isOpen={isModalArchiOpen}
                setIsOpenModal={setIsModalArchiOpen}
              />
            </div>
          ),
          currentUser ? (
            <VpButton
              variant="secondary"
              key="header_chip_user"
              data-testid="personal-offer_chip_user"
              className="personal-offer_chip_user"
              onClick={() => setIsModalOpen(!isModalOpen)}
            >
              <VpIcon name="user" />
              {currentUser.username}
            </VpButton>
          ) : null,
          <div
            key="header_divider"
            className="vtmn-flex vtmn-h-6 vtmn-w-4 vtmn-m-4"
          >
            <VpDivider id="divider-label-id" orientation="vertical" />
          </div>,
          <div key="cs-apps-wheel" className="gt-tablet:vtmn-flex">
            <CsAppsWheel
              key="cs_appswheel"
              data-testid="cs-apps-wheel"
              env={environment.production ? 'prod' : 'preprod'}
              vtmnCompliant
              lang="en"
            />
          </div>,
        ]}
      />
    </>
  );
};
